import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	atlasShortcutText: {
		id: 'jira.global-shortcuts.shortcut-text.atlas',
		defaultMessage: 'Atlas',
		description: 'Label for Atlas shortcut',
	},
	goalsShortcutText: {
		id: 'jira.global-shortcuts.shortcut-text.goals',
		defaultMessage: 'Goals',
		description: 'Label for Goals product shortcut',
	},
	assetsShortcutText: {
		id: 'jira.global-shortcuts.shortcut-text.assets',
		defaultMessage: 'Assets',
		description: 'Label for Assets product shortcut',
	},
	projectsShortcutText: {
		id: 'jira.global-shortcuts.shortcut-text.projects',
		defaultMessage: 'Projects',
		description: 'Label for Projects product shortcut',
	},
	teamsShortcutText: {
		id: 'jira.global-shortcuts.shortcut-text.teams',
		defaultMessage: 'Teams',
		description: 'Label for Teams product shortcut',
	},
	opsgenieShortcutText: {
		id: 'jira.global-shortcuts.shortcut-text.opsgenie',
		defaultMessage: 'Opsgenie',
		description: 'Label for Opsgenie product shortcut',
	},
});
